import { usePatchApiAdminCompany, } from '../../generated/sitComponents';
import { updateAdminCompanyTreeQueryData } from './query';
export function usePatchAdminCompany(options) {
    return usePatchApiAdminCompany({
        ...options,
        onSuccess: (data, variables, onMutateResult, context) => {
            updateAdminCompanyTreeQueryData(context.client, variables.pathParams.id, (company) => {
                return {
                    ...company,
                    ...variables.body,
                };
            });
            options?.onSuccess?.(data, variables, onMutateResult, context);
        },
        onSettled: (data, error, variables, onMutateResult, context) => {
            context.client.invalidateQueries({ queryKey: ['admin', 'companies'] });
            options?.onSettled?.(data, error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-patch-admin-company.js.map